import { useTranslation } from "react-i18next";

import useIsActive from "hooks/useIsActive";

import Button from "components/Button";
import Container from "components/Container";
import Footer from "components/Footer";
import { Form, FormField } from "components/Form";
import Input from "components/Input";
import Textarea from "components/Textarea";

import useClinic from "./useClinic";

export default function Clinic() {
  const { t } = useTranslation();

  useIsActive();

  const { form, onSubmit, handleSubmit, isDirty } = useClinic();

  const { control } = form;

  return (
    <>
      <Form {...form}>
        <form onSubmit={handleSubmit(onSubmit)} id="clinic-form">
          <Container>
            <div className="flex flex-col gap-2.5">
              <div>{t("profile.clinic.clinicInformation")}</div>
              <div className="flex flex-col gap-3.5">
                <FormField
                  control={control}
                  name="name"
                  render={({ field }) => (
                    <Input {...field} label={t("profile.clinic.name")} placeholder={t("profile.clinic.name")} />
                  )}
                />
                <FormField
                  control={control}
                  name="address"
                  render={({ field }) => (
                    <Input {...field} label={t("profile.clinic.address")} placeholder={t("profile.clinic.address")} />
                  )}
                />
                <FormField
                  control={control}
                  name="description"
                  render={({ field }) => (
                    <Textarea
                      {...field}
                      label={t("profile.clinic.description")}
                      placeholder={t("profile.clinic.description")}
                    />
                  )}
                />
                <FormField
                  control={control}
                  name="website"
                  render={({ field }) => (
                    <Input {...field} label={t("profile.clinic.website")} placeholder={t("profile.clinic.website")} />
                  )}
                />
                <FormField
                  control={control}
                  name="phone"
                  render={({ field }) => (
                    <Input {...field} label={t("profile.clinic.phone")} placeholder={t("profile.clinic.phone")} />
                  )}
                />

                <FormField
                  control={control}
                  name="email"
                  render={({ field }) => (
                    <Input {...field} label={t("profile.clinic.email")} placeholder={t("profile.clinic.email")} />
                  )}
                />
              </div>
            </div>
          </Container>
        </form>
      </Form>
      <Footer className="md:justify-end">
        <Button disabled={!isDirty} className="w-full md:w-60" type="submit" form="clinic-form" variant="primary">
          {t("button.saveChanges")}
        </Button>
      </Footer>
    </>
  );
}
